import { useEffect, useId, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ToolIcon } from '@/lib/tools'
import { disciplines, DisciplineSymbol } from '@/lib/trainingDisciplines'

export default function TrainingNavDropdown() {
  const [open, setOpen] = useState(false)
  const root = useRef(null)
  const trigger = useRef(null)
  const id = useId()
  const location = useLocation()
  useEffect(() => { setOpen(false) }, [location])
  useEffect(() => {
    if (!open) return
    const outside = (e) => { if (!root.current?.contains(e.target)) setOpen(false) }
    document.addEventListener('pointerdown', outside)
    return () => document.removeEventListener('pointerdown', outside)
  }, [open])
  return <div className="training-nav" ref={root} onMouseEnter={() => setOpen(true)} onMouseLeave={() => {
    if (!root.current?.querySelector('nav')?.contains(document.activeElement)) setOpen(false)
  }} onBlur={(e) => { if (!e.currentTarget.contains(e.relatedTarget)) setOpen(false) }} onKeyDown={(e) => {
    if (e.key === 'Escape') { setOpen(false); trigger.current?.focus() }
    if (e.key === 'ArrowDown' && e.target === trigger.current) {
      e.preventDefault(); setOpen(true)
      requestAnimationFrame(() => root.current?.querySelector('nav a')?.focus())
    }
  }}>
    <Link ref={trigger} to="/training" className="dash-tool-chip" style={{ '--chip-color': '#22c55e' }} aria-expanded={open} aria-controls={id} onClick={() => setOpen(false)}>
      <span className="dash-tool-chip-icon" style={{ background: '#22c55e' }}><ToolIcon kind="check" /></span>
      <span>Training</span><svg className="training-nav-chevron" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="m3 4.5 3 3 3-3" stroke="currentColor" strokeWidth="1.5" /></svg>
    </Link>
    {open && <nav id={id} className="training-nav-panel" aria-label="Training categories">
      {disciplines.map(({ name, path, color, ink }) => <Link key={path} to={`/training/${path}`} className="dash-tool-chip training-nav-category" style={{ '--chip-color': color }} onClick={() => setOpen(false)}>
        <span className="dash-tool-chip-icon" style={{ background: color, color: ink }}><DisciplineSymbol discipline={path} /></span><span>{name}</span><span className="training-nav-arrow" aria-hidden="true">↗</span>
      </Link>)}
      <Link to="/training" className="training-nav-overview" onClick={() => setOpen(false)}>Training overview <span aria-hidden="true">→</span></Link>
    </nav>}
  </div>
}
